import { mapState, mapActions } from 'vuex'

export default {
  name: 'Responses',
  inject: ['$parseDateTime'],
  props: {
    targetStats: {
      type: String,
      default: 'impressions',
    },
  },
  data() {
    return {
      sizeOptions: [10, 20, 30],
    }
  },
  computed: {
    ...mapState({
      targetCampaignUUID: (state) => state.campaign.targetCampaignUUID,
      responses: (state) => state.campaign.analytics.responses.campaignResponses,
      getResponsesLoading: (state) => state.campaign.analytics.responses.getResponsesLoading,
      getResponsesCompleted: (state) => state.campaign.analytics.responses.getResponsesCompleted,
      getResponsesError: (state) => state.campaign.analytics.responses.getResponsesError,
      activeSize: (state) => state.campaign.analytics.responses.activeSize,
      activePage: (state) => state.campaign.analytics.responses.activePage,
      activeSort: (state) => state.campaign.analytics.responses.activeSort,
      activeSortDirection: (state) => state.campaign.analytics.responses.activeSortDirection,
    }),
    localActiveSize: {
      get() {
        return this.activeSize
      },
      set(value) {
        // variable will be set from the "triggerActiveSizeChange"
      },
    },
    campaign() {
      return this.$store.getters['campaign/targetCampaign']
    },
  },
  watch: {
    targetStats(newVal) {
      if (this.targetCampaignUUID) {
        this.getCampaignResponses({
          uuid: this.targetCampaignUUID,
          size: this.activeSize,
          pageNumber: this.activePage,
          sortBy: this.activeSort,
          sortDirection: this.activeSortDirection,
          targetStats: newVal,
        })
      }
    },
  },
  methods: {
    ...mapActions('campaign/analytics/responses', ['getCampaignResponses']),
    triggerActiveSizeChange(newSize) {
      this.getCampaignResponses({
        uuid: this.targetCampaignUUID,
        size: newSize,
        pageNumber: this.activePage,
        sortBy: this.activeSort,
        sortDirection: this.activeSortDirection,
        targetStats: this.targetStats,
      })
    },
    pageChange(newPage) {
      this.getCampaignResponses({
        uuid: this.targetCampaignUUID,
        size: this.activeSize,
        pageNumber: newPage,
        sortBy: this.activeSort,
        sortDirection: this.activeSortDirection,
        targetStats: this.targetStats,
      })
    },
    getWidgetNameByID(id) {
      const widget = this.campaign.widgetItems.find((item) => {
        return item.id === id
      })

      return widget.name ? widget.name : 'No name'
    },
    getContentItemLabel(widgetID, stepID, contentItemID, index) {
      const widget = this.campaign.widgetItems.find(
        (item) => item.id === widgetID)

      if (!widget) {
        return 'answer #' + index
      }

      const step = widget.steps.find((item) => item.id === stepID)

      if (!step) {
        return 'answer #' + index
      }

      const contentItem = step.contentItems.find(
        (item) => item.id === contentItemID)

      if (!contentItem) {
        return 'answer #' + index
      }

      return contentItem.settings ? contentItem.settings.label : 'answer #' +
        index
    },
    sortMethod(sortProps) {
      let activeSort = this.activeSort
      let activeSortDirection = this.activeSortDirection

      if (activeSort !== sortProps.column.property) {
        activeSort = sortProps.column.property
        activeSortDirection = 1
      } else {
        activeSortDirection *= -1
      }

      this.getCampaignResponses({
        uuid: this.targetCampaignUUID,
        size: this.activeSize,
        pageNumber: this.activePage,
        sortBy: activeSort,
        sortDirection: activeSortDirection,
        targetStats: this.targetStats,
      })
    },
  },
}
